import React, { createContext, useState } from 'react';
import { TypeSetState } from '../global';
import { GameSettings, HobbyistMode } from '../settings/modes';

interface GameSettingsProviderProps {
	children: React.ReactNode;
}

interface IGameSettingProvider {
	gameSettings: GameSettings,
	setGameSettings: TypeSetState<GameSettings>
}

const defaultContext: IGameSettingProvider = {
	gameSettings: HobbyistMode,
	setGameSettings: () => {
	}
};
export const GameSettingsContext: React.Context<IGameSettingProvider> = createContext(defaultContext);

export const GameSettingProvider = ({ children }: GameSettingsProviderProps) => {
	const [gameSettings, setGameSettings] = useState(defaultContext.gameSettings);
	return <GameSettingsContext.Provider
		value={{ gameSettings, setGameSettings }}> {children}</GameSettingsContext.Provider>;

};